import $ from 'jquery';
import trimHtml from 'trim-html';

export function tabsWrapper() {
  $('.tabs')[0].children[0].classList.add("active");

  let tabContents = $('.tab-content');
  for (let i = 0; i < tabContents.length; i++) {
    let tabContent = $(tabContents[i]);
    let tabText = tabContent.find(".trimmed-text")[0];

    if (i > 0) {
      let result = trimHtml(tabText.innerHTML, { limit: 200 });
      tabText.innerHTML = result.html;
      tabText.classList.remove('hidden');
    }
  }

  $('.tab-button').on('click', function () {
    let id = $(this)[0].id;
    let tabButtons = $('.tab-button');
    for (let i = 0; i < tabButtons.length; i++) {
      if (tabButtons[i].id === id) tabButtons[i].classList.add('active');
      else tabButtons[i].classList.remove('active');
    }

    let tabContents = $('.tab-content');
    for (let i = 0; i < tabContents.length; i++) {
      if (tabContents[i].id === id) {
        tabContents[i].classList.remove('hidden');
        tabContents[i].classList.add('active');
      } else {
        tabContents[i].classList.remove('active');
        tabContents[i].classList.add('hidden');
      }
    }
  });

  $('.read-more').on('click', function () {
    let readMoreButton = $(this);
    let trimmedText = $(this).parent().find('.trimmed-text');
    let fullText = $(this).parent().find('.full-text');
    readMoreButton[0].classList.add('hidden');
    trimmedText[0].classList.add('hidden');
    fullText[0].classList.remove('hidden');
  });

  $('.read-less').on('click', function () {
    let fullText = $(this).parent().parent().find('.full-text');
    let trimmedText = $(this).parent().parent().find('.trimmed-text');
    let readMoreButton = $(this).parent().parent().find('.read-more');
    fullText[0].classList.add('hidden');
    trimmedText[0].classList.remove('hidden');
    readMoreButton[0].classList.remove('hidden');
  });
}
